<!-- 多用户展示标签（用于将用户id数组转为用户名显示） 作者：PeterLee 最新更新时间：2026-03-24 -->
<template>
  <div class="multi-user-label">
    {{ names }}
  </div>
</template>

<script>
/**
 * 多用户展示标签组件
 * 用于表格中将用户id数组转换为用户名显示
 * 使用示例：<multi-user-label v-model="scope.row.userIds"></multi-user-label>
 */
import {getBatchUser} from "@/api/systemApi"
export default {
  name: "MultiUserLabel",
  //设置v-model绑定对象
  model: {
    prop: 'ids',
  },
  props: {
    // 用户id数组
    ids: {
      type: Array,
      default: () => []
    },
    // 分隔符，默认逗号+空格
    separator: {
      type: String,
      default: ', '
    }
  },
  data() {
    return {
      // 用户名显示
      names: ""
    };
  },
  watch: {
    ids: {
      handler(val) {
        if (val && val.length > 0) {
          this.getBatchUserNames()
        } else {
          this.names = ""
        }
      },
      immediate: true
    }
  },
  methods: {
    // 批量获取用户名
    getBatchUserNames() {
      if (!this.ids || this.ids.length === 0) {
        this.names = ""
        return
      }
      this.$nextTick(() => {
        getBatchUser(this.ids).then(res => {
          if (res.code === 200 && res.data) {
            this.names = res.data.map(u => u.name).join(this.separator)
          } else {
            this.names = "加载失败"
          }
        }).catch(() => {
          this.names = "加载失败"
        })
      })
    }
  }
}
</script>

<style scoped>
.multi-user-label {
  display: inline-block;
}
</style>
